export default __webpack_public_path__ + "static/media/submit-request.0d9af048.svg";